import { QuantityDistributionErrorType } from './automationsHelpers'

export const discountCatalogueErrors = (
  errors: Record<string, string>,
  path: string
): QuantityDistributionErrorType[] => {
  if (!errors) return []

  const groupErrors: QuantityDistributionErrorType[] = []

  const groupIndices = new Set<number>()
  const prefix = `${path}.`
  const suffix = `.entities`

  Object.keys(errors).forEach(key => {
    if (key.startsWith(prefix) && key.endsWith(suffix)) {
      const index = parseInt(key.slice(prefix.length, key.length - suffix.length))
      if (!isNaN(index)) groupIndices.add(index)
    }
  })

  groupIndices.forEach(index => {
    const entitiesError = errors[`${path}.${index}.entities`]
    groupErrors[index] = {
      minimumValue: { status: false },
      maximumValue: { status: false },
      selectedItems: entitiesError ? { status: true, message: entitiesError } : { status: false }
    }
  })

  return groupErrors
}

export const getCatalogueGroupError = (errors: QuantityDistributionErrorType[], groupIndex: number): string => {
  if (!errors) return ''

  const groupError = errors[groupIndex]
  if (!groupError) return ''

  if (groupError.selectedItems?.status && groupError.selectedItems?.message) {
    return groupError.selectedItems.message
  }

  return ''
}
